import { render } from "./form.vue?vue&type=template&id=45536d89"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"

import exportComponent from "/Users/agostinodegirolamo/Dropbox/Mac/Documents/Progetti/TTRE/Rapportino/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__